module.exports = __webpack_public_path__ + "static/media/nuestra-rifa.b4af8d7e.png";